<template>
  <label class="d-flex align-items-start mb-0 input-plain-text">
    <input
      v-model="valueModel"
      class="flex-shrink-1 form-control-plaintext"
      v-bind="inputProps"
      v-on="{
        ...$listeners,
        input,
      }"
    />
  </label>
</template>

<script>
import { prop } from '@/utils/factories';

export default {
  name: 'InputPlainText',
  props: {
    value: prop([String, Number]),
    inputProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valueModel: this.value,
    };
  },
  methods: {
    input() {
      this.$emit('input', this.valueModel);
    },
  },
};
</script>

<style lang="scss">
.input-plain-text {
  > input {
    color: inherit;
    font-size: inherit;
  }
}
</style>
